/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Seller_Calendar_Payout_StatusInputs */

const en_seller_calendar_payout_status = /** @type {(inputs: Seller_Calendar_Payout_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Payout Status`)
};

const es_seller_calendar_payout_status = /** @type {(inputs: Seller_Calendar_Payout_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estado del Pago`)
};

const fr_seller_calendar_payout_status = /** @type {(inputs: Seller_Calendar_Payout_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Statut du paiement`)
};

const de_seller_calendar_payout_status = /** @type {(inputs: Seller_Calendar_Payout_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auszahlungsstatus`)
};

const id_seller_calendar_payout_status = /** @type {(inputs: Seller_Calendar_Payout_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Status Pembayaran`)
};

/** @type {(inputs: Seller_Calendar_Payout_StatusInputs) => LocalizedString} */
const ja_seller_calendar_payout_status = en_seller_calendar_payout_status;

/** @type {(inputs: Seller_Calendar_Payout_StatusInputs) => LocalizedString} */
const zh_seller_calendar_payout_status = en_seller_calendar_payout_status;

/** @type {(inputs: Seller_Calendar_Payout_StatusInputs) => LocalizedString} */
const ar_seller_calendar_payout_status = en_seller_calendar_payout_status;

/** @type {(inputs: Seller_Calendar_Payout_StatusInputs) => LocalizedString} */
const it_seller_calendar_payout_status = en_seller_calendar_payout_status;

/** @type {(inputs: Seller_Calendar_Payout_StatusInputs) => LocalizedString} */
const ru_seller_calendar_payout_status = en_seller_calendar_payout_status;

/** @type {(inputs: Seller_Calendar_Payout_StatusInputs) => LocalizedString} */
const pt_seller_calendar_payout_status = en_seller_calendar_payout_status;

/** @type {(inputs: Seller_Calendar_Payout_StatusInputs) => LocalizedString} */
const ko_seller_calendar_payout_status = en_seller_calendar_payout_status;

/**
* | output |
* | --- |
* | "Payout Status" |
*
* @param {Seller_Calendar_Payout_StatusInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const seller_calendar_payout_status = /** @type {((inputs?: Seller_Calendar_Payout_StatusInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seller_Calendar_Payout_StatusInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_seller_calendar_payout_status(inputs)
	if (locale === "es") return es_seller_calendar_payout_status(inputs)
	if (locale === "fr") return fr_seller_calendar_payout_status(inputs)
	if (locale === "de") return de_seller_calendar_payout_status(inputs)
	if (locale === "ja") return ja_seller_calendar_payout_status(inputs)
	if (locale === "zh") return zh_seller_calendar_payout_status(inputs)
	if (locale === "ar") return ar_seller_calendar_payout_status(inputs)
	if (locale === "id") return id_seller_calendar_payout_status(inputs)
	if (locale === "it") return it_seller_calendar_payout_status(inputs)
	if (locale === "ru") return ru_seller_calendar_payout_status(inputs)
	if (locale === "pt") return pt_seller_calendar_payout_status(inputs)
	return ko_seller_calendar_payout_status(inputs)
});